import { forEach } from 'lodash';
import {
  CLEAR_PAGE_API_DATA,
  FETCH_GET_API_FAILURE,
  FETCH_GET_API_LOADING,
  FETCH_GET_API_SUCCESS,
  UPDATE_PAGE_STATE,
} from '../redux/action';

const init = {
  loading: true,
  error: null,
  data: null,
  meta: {},
};

export default (state = {}, action) => {
  const newState = { ...state };
  switch (action.type) {
    case FETCH_GET_API_LOADING:
      newState[action.key] = { ...init, data: action.payload.init, loading: true, meta: action.payload.apiMeta };
      break;

    case FETCH_GET_API_SUCCESS:
    case UPDATE_PAGE_STATE:
      newState[action.key] = {
        error: null,
        loading: false,
        data: action.payload,
        meta: action.meta ?? newState[action.key]?.meta,
      };
      break;

    case CLEAR_PAGE_API_DATA:
      forEach(action.payload, (key) => {
        delete newState[key];
      });
      break;

    case FETCH_GET_API_FAILURE:
      newState[action.key] = {
        error: action.error,
        loading: false,
        data: null,
        meta: newState[action.key]?.meta || {},
      };
      break;

    default:
  }
  return newState;
};
